var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSz = function SvgSz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M22.81 17.216A11.953 11.953 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 6.26l-10.81.522A11.953 11.953 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.217l10.81.522 10.81-.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 0A12 12 0 0 0 1.19 6.783H22.81A12 12 0 0 0 11.999 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24a12 12 0 0 1-10.81-6.783H22.81a12 12 0 0 1-10.81 6.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M23.433 8.348H.567A11.991 11.991 0 0 0 0 12c0 1.274.2 2.5.567 3.652h22.866A11.99 11.99 0 0 0 24 12c0-1.274-.2-2.5-.567-3.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M19.826 11.48H4.174v1.043h15.652v-1.044ZM17.739 9.391H6.261v1.044h11.478V9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M17.813 12S15.13 15.13 12 15.13 8.87 12 8.87 12s0-3.13 3.13-3.13S17.813 12 17.813 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 15.13C8.868 15.13 6.185 12 6.185 12s2.683-3.13 5.813-3.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M10.957 10.957H9.913v2.087h1.044v-2.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.086 10.957h-1.043v2.087h1.043v-2.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M4.174 13.044a1.043 1.043 0 1 0 0-2.086 1.043 1.043 0 0 0 0 2.086ZM19.827 13.044a1.044 1.044 0 1 0 0-2.087 1.044 1.044 0 0 0 0 2.087Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSz;